<template> 
  <div class="good-details">
    <Head :goBack='true' show="" :backPath="'/mall/phone/home'" title="商品详情"></Head>
    <div class="kong">&nbsp;</div>
    <div class="goods"> 
      <SwipeDemo 
        id="swipeone"
        :options="swiperOptions">
        <SwipeItem v-for="(item,index) in goodinfo.imgs" :key="index">
            <img @click="magnifyImg(index)" :src="item" alt="" class="g-img">
        </SwipeItem>
      </SwipeDemo>
      <div class="goods_price_content">
          <div class="goods-title">{{ goodinfo.title }}</div>
          <div class="goods-price">￥ {{data.money }}</div> 
          <span class="goods-unit">单位：{{ goodinfo.unit }}</span> <span class="goods-stock">库存：{{ data.stock }}</span>
      </div>
        <div class="goods_cell_group" v-if="goodinfo.specs.length>0">
        <div class="goods_cell_title">商品规格</div>
        <div class="good-specs cl">
          <div v-for="(item,i) in goodinfo.specs" @click="setSpecs(i+1,item)" :key="i" :class="[i+1==sign?'not-pitch-on pitch-on cl':'not-pitch-on cl','good-specs_dev']">
            <span class="good-specs_span">{{item.title}}</span>
            <span class="good-specs_span">￥{{item.price}}</span>
          </div>
        </div>
      </div>
      <div class="goods_cell_group" v-if="goodinfo.recipe&&goodinfo.recipe.customSugar">
        <div class="goods_cell_title">甜度</div>
        <div class="good-specs cl">
          <div v-for="(item,i) in sugarList" @click="setSugar(item.index)" :key="i" :class="[item.index==sugarIndex?'not-pitch-on pitch-on cl':'not-pitch-on cl','good-specs_dev']">
            <span class="good-specs_span">{{item.title}}</span>
          </div>
        </div>
      </div>
      <div class="goods_cell_group" v-if="goodinfo.recipe">
        <div class="goods_cell_title">加料</div>
        <div class="good-specs cl">
          <div v-for="(item,i) in goodinfo.recipe.customMaterials" @click="setMaterials(item.id,item)" :key="i" :class="[item.id==materialsIndex?'not-pitch-on pitch-on cl':'not-pitch-on cl','good-specs_dev']">
            <span class="good-specs_span">{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="goods_cell_group">
        <div class="goods_cell_title">
          <div>
            {{ couponData.id?'选中优惠券':'选择优惠券' }}
          </div>
          <div class="goods-coupon-box" @click="openCoupon">
            <div class="goods-coupon-tip" v-if="!couponData.id">
              {{couponCount?couponCount+'张可用':'关注公众号领取优惠券'}}
              <!-- <span class="goods-coupon-tip-span">（最多可减20元）</span> -->
            </div>
            <div class="goods-coupon-tip" v-else>
              <span v-if="couponData.type =='1'||couponData.type =='2'">-{{couponData.discount}}元</span>
              <span v-else-if="couponData.type =='3'"> {{couponData.discount/10 }}折 </span>
            </div>
            <van-icon  class="goods-coupon-ico" name="arrow" />
          </div>
        </div>
      </div>
      <div class="goods_cell_group">
        <div class="goods_cell_title">商品详情</div>
      </div>
        <div v-html="goodinfo.description" class="goods-description"></div> 
      <van-goods-action>
        <van-goods-action-button type="danger" class="goods-go" @click="sorry">
          立即购买
          <span v-if="couponData.id" >{{newMoney}}元</span>
          <span v-else >{{data.money.toFixed(2) }}元</span>
          <s v-if="couponData.id" style="color:rgba(255,255,255,0.6);margin-left: 15px;">{{data.money.toFixed(2) }}元</s>
        </van-goods-action-button> 
      </van-goods-action>
  </div>
  <mode-of-payment ref="payment" :paymentId="paymentId"  @selectEvent="selectEvent" />
  <login-modal ref="login"/>
</div>
</template>
<script>
import Vue from 'vue';
import {mapActions} from "vuex";
import { ImagePreview,Toast ,Dialog } from "vant";
import ModeOfPayment from "@/components/ModeOfPayment";
import LoginModal from "@/components/LoginModal";
export default {
  name:"goodDetails",
  components: {
    ImagePreview,
    modeOfPayment:ModeOfPayment,
    LoginModal:LoginModal,
  },
  computed: {
    newMoney() {
      var num = 0
      if(this.couponData.id){
        if(this.couponData.type =='1'||this.couponData.type =='2'){
          var newNum = this.data.money - this.couponData.discount
          num =  (newNum>0?newNum:0.01).toFixed(2)
        }else{
          num =  (this.data.money*this.couponData.discount/100).toFixed(2)
        }
      }
      return num
    }
  },
  data() {
    return {
      paymentId:"",
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          delay:4000
        }
      },
      id: '',
      goodId:"",
      data:{
        money:0,
        cellId: 0,
        deviceNum: "",
        goodId: 0,
        skuId: null,
        stock:0,
        customId: null,
        sugar: 0,
      },
      sugarIndex:0,
      sugarList:[
        { title:'无糖', index:0 },
        { title:'三分糖', index:3 },
        { title:'五分糖', index:5 },
        { title:'七分糖', index:7 },
        { title:'全糖',  index:10 },
      ],
      materialsIndex:'',
      materialsIndexs:'',
      signs:"",
      sign:"",
      goodinfo:{
        description: "",
        imgs:[],
        goodId:"",
        goodPrice: "",
        goodType: "",
        mainImage:"",
        specs:[],
        recipe: {
          customMaterials: [],
          customSugar: false,
          desc: "",
          hot: '',
          ice: '',
          id: '',
          maxSugar: '',
          milk:'',
          name: '',
          totalWater: '',
          recipeId: '',
          couponId :''
        },
        subTitle: '',
        title: '',
        unit: '',
      },
      out_trade_no: '',
      couponData: {
        money:0
      },
      couponCount:0
    }; 
  },
  created() { 
    let id = this.$route.query.id*1;
    let goodId = this.$route.query.goodId*1;
    if (!id) {
      this.$router.push({name: 'home'})
    } else {
      this.goodId=goodId
      this.id = id;
      console.log(this.$route.query)
      if (this.$route.query.couponData && this.$route.query.couponData.id) {
        this.couponData =  this.$route.query.couponData
      }
      this.getDataInfo(id)
    }
    this.getCouponCount()
  },
  methods: { 
    ...mapActions(['getUserMoney']),
    getCouponCount(){
      if(this.userToken){
        let data={
          // deviceNum:this.deviceNum
        }
        this.$api.coupon.getCouponCount(data).then(res=>{
          if(res.code==200){
            this.couponCount = res.couponCount
          }
        })
      }
    },
    openCoupon() {
      if (this.userToken) {
        if(this.couponCount&&this.couponCount>0){
          let params ={
            id:this.id,
            goodId: this.goodId,
            money:this.data.money
          }
          this.$router.push({
            name: 'coupon', query: params
          })
        }else{
          this.$router.push({
            name: 'focus'
          })
        }
      }else{
        this.$refs.login.control()
      }
    },
    // 支付方式
    selectEvent(val){
      this.paymentId=val
      if(this.paymentId==1){
        this.alipayPhone()
      }else if(this.paymentId==2){
        this.wechatPhone()
      }else if(this.paymentId==3){
        this.moneyPhone()
      }
    },
    // 设置规格
    setSpecs(i,item){
      this.sign=i
      if(this.signs&&this.signs==this.sign){
        this.signs =''
        this.sign=''
        this.data.money=this.goodinfo.goodPrice
        this.data.stock =this.goodinfo.currentStock
        this.data.skuId=null
      }else{
        this.signs=this.sign
        this.data.money=item.price
        this.data.skuId=item.specId
        this.data.stock =Math.floor(this.goodinfo.currentStock/item.num)
      }
    },
    // 糖度
    setSugar(i){
      this.sugarIndex=i
      if(this.sugarIndex){
        this.data.sugar= this.sugarIndex*this.goodinfo.recipe.maxSugar
      }else{
        this.data.sugar=0
      }
    },
    // 加料
    setMaterials(i,item){
      this.materialsIndex=i
      if(this.materialsIndexs&&this.materialsIndexs==this.materialsIndex){
        this.materialsIndexs =''
        this.materialsIndex=''
        this.data.customId=null
      }else{
        this.materialsIndexs=this.materialsIndex
        this.data.customId=this.materialsIndex
      }
    },
    // 购买
    sorry(){
      if(this.goodinfo.specs.length>0){
        if(this.sign){
          if (this.loginType == 2) {
            if(this.userToken){
              this.$refs.payment.control()
            }else{
              this.$refs.login.control()
            }
          }else{
            this.$refs.payment.control()
          }
        }else{
          Toast('请选择规格')
        }
      }else{
        if (this.loginType == 2) {
            if(this.userToken){
              this.$refs.payment.control()
            }else{
              this.$refs.login.control()
            }
        }else{
          this.$refs.payment.control()
        }
      }
    },
    // 获取详情
    getDataInfo() { 
      let data={
        cellId :this.id
      }
      this.$api.good.goodDetail(data).then((res)=>{
        if(res.code==200){
          this.goodinfo =res.data
          // customId: 0,
          // sugar: 0,
          this.data.deviceNum=this.deviceNum
          this.data.goodId=res.data.goodId
          this.data.cellId=res.data.cellId
          this.data.money=res.data.cellPrice ||res.data.goodPrice  
          this.data.stock = res.data.currentStock
          this.data.couponId = this.couponData.id||''
          
          this.sugarIndex=0
          this.materialsIndex=''
        }else{
          Toast(res.msg)
        }
      })
    }, 
    // 支付宝支付
    alipayPhone() {
      const params = Object.assign({}, this.data)
      if (!params.couponId) {
        delete params.couponId
      }
      this.$api.good.alipayPhone(params).then((res)=>{
          this.$refs.payment.disabledFn()
          this.$refs.payment.control()   
        if(res.code==200){
          window.location.href=res.sign
        }else{
          Toast(res.msg)
        }
      }).catch((err) =>{ 
        this.$refs.payment.disabledFn()
        this.$refs.payment.control()   
      });
    },
    // 微信支付
    wechatPhone() {
      const params = Object.assign({}, this.data)
      if (!params.couponId) {
        delete params.couponId
      }
      this.$api.good.wechatPhone(params).then(res => {
          if(res.code==200){
            this.$refs.payment.disabledFn()
            this.out_trade_no=res.data.out_trade_no
            this.onBridgeReady(res.data)
          }else{
            this.$refs.payment.disabledFn()
            this.$refs.payment.control()
            Toast(res.msg)
          }
      }).catch((err) =>{ 
        this.$refs.payment.disabledFn()
        this.$refs.payment.control()   
      });
    },
    // 微信支付签名接口
    onBridgeReady(params){
    let that=this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          appId: params.appId, // 公众号名称，由商户传入
          timeStamp: params.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: params.nonceStr, // 随机串
          package: params.package,
          signType: params.signType, // 微信签名方式：
          paySign: params.paySign, // 微信签名
        },
        function(res){
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
              that.getUserMoney()
           
              // that.$router.push({ name: 'home' })
              that.paySuccess(res)
          } else if(res.err_msg =='get_brand_wcpay_request:cancel'){
              that.$refs.payment.control()
            Toast("您已取消了支付")
          }else{
            that.getUserMoney()
            that.$refs.payment.control()
            Toast("支付失败，请重新支付")
          }
        }
      )
    },
    // 支持成功后的判断
    paySuccess(v) {
      Toast("支付成功")
      if (v.activityType) {
        let params = {
        activityId: v.activityId,
        activityType: v.activityType,
        orderNo:v.orderNo
        }
        if (v.activityType=='2') {
          this.$router.push({name: 'home',query: params})
        } else if(v.activityType=='3') {
          this.$router.push({path: '/mall/phone/lottery', query: params})
        }
      } else {
        this.$router.push({name: 'home'})
      }
    },
    // 余额支付
    moneyPhone() {
      const params = Object.assign({}, this.data)
      if (!params.couponId) {
        delete params.couponId
      }
      this.$api.good.moneyPhone(params).then(res => {
          if(res.code==200){
            this.$refs.payment.disabledFn()
            this.getUserMoney()
            this.paySuccess(res)
            // this.$router.push({name: 'home'})
          }else{
            this.getUserMoney()
            this.$refs.payment.disabledFn()
            Toast(res.msg)
          }
      }).catch((err) =>{ 
        this.$refs.payment.disabledFn()
        this.$refs.payment.control()   
      });
    },
    // 轮播图
    magnifyImg(index){
      if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            ImagePreview({
              images: this.goodinfo.imgs,
              startPosition: index,
              onClose() {
              
              }
            });
        // console.log('移动端')
      }else{
        // console.log('PC端')
      }
    },
  }
};
</script>
<style scoped>
.good-details{
  height: 100%;
  font-size: 20px;
  width: 100%;
  background-color:#f7f8fa;
}
#swipeone {
  box-shadow: 0 8px 12px #ebedf0;
}
#guide ,#swipeone ,.g-img{
  width:100%;
  height:500px;
}
.good-details .kong{
  width: 100%;
  height: 100px;
}
.good-details .goods {
  height: calc(100% - 88px);
  width: 100%;
}
.good-details /deep/ .goods-swipe  img {
  width: 100%;
  display: block;
  height: 500px;
}
.goods_price_content{
  padding: 20px 30px;
  background-color: #fff;
}
.goods_price_content .goods-title{
  color:#6e6e6e;
  font-size: 32px;
  font-weight: bold;
  padding: 10px 0;
}
.goods_price_content .goods-price{
  font-size: 32px;
  color: #f44;
  padding: 10px 0;
}
.goods_price_content .goods-price span{
  font-size: 24px;
}
.goods_price_content span{
  display: inline-block;
  color:#6e6e6e;
  font-size: 28px;
  padding: 10px 0;
}
.goods_price_content .goods-unit{
  width: 50%;
}
.goods_cell_group{
  padding: 20px 30px;
  background-color: #fff;
  border-top: 2px solid #f2f2f2;
}
.goods_cell_group .goods_cell_title{
  font-size: 27px;
  padding: 2px;
  color: #6e6e6e;
  display: flex;
  justify-content:space-between;
  align-items: center;
}
.good-details .goods-cell-group{
  padding: 14px 0;
  background-color:#f6f9fd;
}
.goods-cell-group /deep/.van-cell{
  font-size: 24px;
  color:#6e6e6e;
}
.goods-cell-group .van-cell .van-cell__title{
  font-size: 28px;
}
.good-details .goods-cell-group /deep/ .van-cell{
  background-color:#f6f9fd;
}
.good-details .goods-cell-group .van-cell__value {
  color: #999;
}
.good-details .goods-tag{
  margin-left: 5px;
}
.van-goods-action{
  width: 100%;
  background: #17a456 !important;
}
.good-details /deep/ .goods-go{
  width: 100%;
  font-size: 36px;
  height: 130px ;
  color: rgb(235, 227, 227);
}
.goods-go span{
  margin-left: 30px;
}
.good-details .van-goods-action /deep/.van-goods-action-button--danger{
  background: #17a456 !important;
}
.loding_now /deep/.van-loading__spinner{
  width: 50px !important;
  height: 50px !important;
}
.good-details /deep/ .van-sku-stepper-stock{
  padding: 24px 0;
}
.good-details /deep/ .van-sku-row{
  padding-bottom: 10px ;
}
.good-details  .goods-description{
  padding: 15px 30px;
  border-top: 2px solid #f2f2f2;
  background-color: #fff;
  color: #6e6e6e;
  min-height:300px;
}
.good-details  .goods-description .description{
  min-height:300px;
  width: 100%;
}
.good-details .goods-cell-group[data-v-7b9e57fb]{
  padding: 0;
}
.good-details  .goods-cell-group-specs{
  font-size: 22px;
  background-color: #fff;
  border-top: 2px solid #f2f2f2;
  border-bottom: 2px solid #f2f2f2;
}
.good-details .goods-cell-group[data-v-7b9e57fb] .van-cell{
  background-color: #fff;
}
.good-details .goods-cell-group[data-v-7b9e57fb]{
  background-color: #fff;
}
.good-details  .good-specs{
  width: 100%;
  min-height: 110px;
  box-sizing: border-box;
  padding: 10px 0;
  background-color: #fff;
  margin-left: -4%;
  overflow: hidden;
}
.good-specs_dev{
  float: left;
  width: 29.3333%;
  box-sizing: border-box;
  margin:1% 0% 1% 4%;
  background-color: #dedede;
  border-radius: 10px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}
.good-specs_span{
  flex: 1;
  font-size: 24px;
}
.good-details  .good-specs /deep/ .van-image__img{
  width: 100%;
}
.good-details  .good-specs .pitch-on{
  background-color: #17a456;
  color:#fff;
}
.good-details  .good-specs /deep/ .van-image .van-image__img{
  width: 100%!important;
  height: 100%!important;
}
.goods-coupon-box{
  display: flex;
  align-items: center;
}
.goods-coupon-tip{
  background-color: #ecd4a6;
  color: #654627;
  padding: 10px 10px 10px 15px;
  border-radius: 8px;
  font-size: 22px;
}
.goods-coupon-tip-span{
  color: #654828;
  font-size: 18px;
}
.goods-coupon-ico{
  font-size: 32px;
  margin-left: 10px;
}
</style>